import React from 'react';
import { Link } from 'react-router-dom';

export type BreadcrumbLinkData = {
  title: string;
  url: string;
  state?: object; 
  onClick?: () => void; // ✅ aggiunto
};

export type BreadcrumbData = {
  links: BreadcrumbLinkData[];
  normal?: boolean;
  white?: boolean;
};

const BreadCrumbComponent: React.FC<BreadcrumbData> = ({ links, normal = false, white = false }) => {
  return (
    <nav className="breadcrumb-container" aria-label="Percorso di navigazione">
      <ul className={`flex text-sm space-x-2 ${white ? 'text-white/70' : 'text-textSecondary'}`}>
        {links.map((d, idx) => {
          const isLast = idx === links.length - 1;

          return (
            <li key={d.url} className="flex items-center">
              {!isLast ? (
                <>
                  <Link
                    to={d.url}
                    state={d.state}
                    onClick={d.onClick}
                    className={white ? 'text-white/80 hover:text-white underline' : 'text-textPrimary underline hover:text-primary'}
                  >
                    {d.title}
                  </Link>
                  <span className={`px-2 ${white ? 'text-white/50' : 'text-textSecondary'}`}>/</span>
                </>
              ) : (
                <span className={white ? 'text-white font-medium' : 'text-textPrimary font-medium'}>{d.title}</span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BreadCrumbComponent;
